import { LoginService } from './../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { map, pluck, switchMap } from 'rxjs/operators';
import { LoginData } from 'src/app/core/models/login-data';
import { Observable, of, BehaviorSubject, combineLatest } from 'rxjs';

const  getAdminNotificationsSubscription = gql`subscription get_notifications($user_id: uuid!) {
  notifications : admin_user_notifications(where: {
    admin_user_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  },
  order_by:{
    created_at: desc
  }) {
    id
    title
    type
    body
    payload
    image
    mark_as_read
    payload
    read_at
    admin_user_id
    created_at
    updated_at
  }
}`;

const  getAdminNotificationsAggregateSubscription = gql`subscription get_notifications_aggregate($user_id: uuid!) {
  notifications_aggregate : admin_user_notifications_aggregate(where: {
    admin_user_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  }){
    aggregate {
      count
    }
  }
}`;



const getDentalSupplierNotificationsSubscription = gql`subscription get_notifications($user_id: uuid!) {
  notifications:dental_supplier_notifications(where: {
    dental_supplier_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  },order_by:{
    created_at: desc
  }) {
    id
    title
    type
    body
    payload
    image
    mark_as_read
    payload
    read_at
    dental_supplier_id
    created_at
    updated_at
  }
}`;

const getDentalSupplierNotificationsAggregateSubscription = gql`subscription get_notifications_aggregate($user_id: uuid!) {
  notifications_aggregate:dental_supplier_notifications_aggregate(where: {
    dental_supplier_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  }){
    aggregate {
      count
    }
  }
}`;

const getDentalPracticeNotificationsSubsription = gql`subscription get_notifications($user_id: uuid!) {
  notifications:dental_practice_notifications(where: {
    dental_practice_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  },
  order_by:{
    created_at: desc
  }) {
    id
    title
    type
    body
    payload
    image
    mark_as_read
    payload
    read_at
    dental_practice_id
    created_at
    updated_at
  }
}`;

const getDentalPracticeNotificationsAggregateSubsription = gql`subscription get_notifications_aggregate($user_id: uuid!) {
  notifications_aggregate:dental_practice_notifications_aggregate(where: {
    dental_practice_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  }){
    aggregate {
      count
    }
  }
}`;


 const getDentalProfessionalNotificationsSubscription = gql`query get_notifications($user_id: uuid!) {
  notifications:dental_professional_notifications(where: {
    dental_professional_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  },
  order_by:{
    created_at: desc
  }) {
    id
    title
    type
    body
    payload
    image
    mark_as_read
    payload
    read_at
    dental_professional_id
    created_at
    updated_at
  }
}`;

const getDentalProfessionalNotificationsAggregateSubscription = gql`query get_notifications_aggregate($user_id: uuid!) {
  notifications_aggregate:dental_professional_notifications_aggregate(where: {
    dental_professional_id: {_eq: $user_id},
    mark_as_read: {_eq: false}
  }){
    aggregate {
      count
    }
  }
}`;

const updateAdminUserNotificationsByPkMutation = gql`mutation update_admin_user_notifications_by_pk($id: uuid!){
  update_admin_user_notifications_by_pk(pk_columns:{id:  $id}, _set: { mark_as_read: true}){
    id
  }
}`;

const updateDentalSupplierNotificationsByPkMutation = gql`mutation update_dental_supplier_notifications_by_pk($id: uuid!){
  update_dental_supplier_notifications_by_pk(pk_columns:{id: $id},  _set: { mark_as_read: true}){
    id
  }
}`;

const updateDentalPracticeNotificationsByPkMutation = gql`mutation update_dental_practice_notifications_by_pk($id: uuid!){
  update_dental_practice_notifications_by_pk(pk_columns:{id:  $id},  _set: { mark_as_read: true}){
    id
  }
}`;

const updateDentalProfessionalNotificationsByPkMutation = gql`mutation update_dental_professional_notifications_by_pk($id: uuid!){
  update_dental_professional_notifications_by_pk(pk_columns:{id: $id},  _set: { mark_as_read: true}){
    id
  }
}`;



const updateAdminUserNotificationsMutation = gql`mutation update_admin_user_notifications{
  update_admin_user_notifications(where:{}, _set: { mark_as_read: true}){
    affected_rows
  }
}`;

const updateDentalSupplierNotificationsMutation = gql`mutation update_dental_supplier_notifications{
  update_dental_supplier_notifications(where: {}, _set:{mark_as_read: true}){
    affected_rows
  }
}`;

const updateDentalPracticeNotificationsMutation = gql`mutation update_dental_practice_notifications{
  update_dental_practice_notifications(where: {}, _set:{mark_as_read: true}){
    affected_rows
  }
}`;

const updateDentalProfessionalNotificationsMutation = gql`mutation update_dental_professional_notifications{
  update_dental_professional_notifications(where:{}, _set:{mark_as_read: true}){
    affected_rows
  }
}`;



@Injectable({
  providedIn: 'root'
})
export class GetNotificationsService {
   notificationSubject = new BehaviorSubject(true);

  constructor(
    private apollo: Apollo,
    private loginService: LoginService
  ) { }


    getNotifications(){
      return this.notificationSubject.pipe(switchMap(data=>{
        return this.getNotificationsObservable();
      }));
    }


  getNotificationsObservable(): Observable<any> {
    const loginData: LoginData = this.loginService.getLoginData();
    if(loginData.type === 'ADMIN'){
      return combineLatest([this.apollo.use('external').subscribe({
        query: getAdminNotificationsSubscription,
        variables: {
          user_id: loginData.id
        }
      }).pipe(pluck('data', 'notifications')),
      this.apollo.use('external').subscribe({
        query: getAdminNotificationsAggregateSubscription,
        variables: {
          user_id: loginData.id
        }
      }).pipe(pluck('data', 'notifications_aggregate'))]
      ).pipe(map(([notifications, notifications_aggregate])=>{
        return {notifications, notifications_aggregate}
      }));
    } else if(loginData.type === 'PROFESSIONAL'){
      return combineLatest([this.apollo.use('external').subscribe({
        query: getDentalProfessionalNotificationsSubscription,
        variables: {
          user_id: loginData.id
        }
      }).pipe(pluck('data', 'notifications')),
      this.apollo.use('external').subscribe({
        query: getDentalProfessionalNotificationsAggregateSubscription,
        variables: {
          user_id: loginData.id
        }
      }).pipe(pluck('data', 'notifications_aggregate'))
    ]).pipe(map(([notifications, notifications_aggregate])=>{
      return {notifications, notifications_aggregate}
    }));
    } else if(loginData.type === 'PRACTICE'){
      return combineLatest([
        this.apollo.use('external').subscribe({
          query: getDentalPracticeNotificationsSubsription,
          variables: {
            user_id: loginData.id
          }
        }).pipe(pluck('data', 'notifications')),
        this.apollo.use('external').subscribe({
          query: getDentalPracticeNotificationsAggregateSubsription,
          variables: {
            user_id: loginData.id
          }
        }).pipe(pluck('data', 'notifications_aggregate'))
      ]).pipe(map(([notifications, notifications_aggregate])=>{
        return {notifications, notifications_aggregate}
      }));
    } else if(loginData.type === 'SUPPLIER'){
      return combineLatest([
        this.apollo.use('external').subscribe({
          query: getDentalSupplierNotificationsSubscription,
          variables: {
            user_id: loginData.id
          }
        }).pipe(pluck('data', 'notifications'))
        ,
        this.apollo.use('external').subscribe({
          query: getDentalSupplierNotificationsAggregateSubscription,
          variables: {
            user_id: loginData.id
          }
        }).pipe(pluck('data', 'notifications_aggregate'))
      ]).pipe(map(([notifications, notifications_aggregate])=>{
        return {notifications, notifications_aggregate}
      })); ;

    } else {
      return of({notifications: [], notifications_aggregate: {aggregate:{count: 0}}})
    }
  }


  updateNotificationByPk(id: string){
    console.log(id);
    const loginData = this.loginService.getLoginData();
    if(loginData.type === 'ADMIN'){
      return this.apollo.use('external').mutate({
        mutation: updateAdminUserNotificationsByPkMutation,
        variables: {id}
      })
    } else if(loginData.type === 'PRACTICE'){
      return this.apollo.use('external').mutate({
        mutation: updateDentalPracticeNotificationsByPkMutation,
        variables: {id}
      })
    } else if(loginData.type === 'PROFESSIONAL'){
      return this.apollo.use('external').mutate({
        mutation: updateDentalProfessionalNotificationsByPkMutation,
        variables: {id}
      });
    } else if(loginData.type === 'SUPPLIER'){
      return this.apollo.use('external').mutate({
        mutation: updateDentalSupplierNotificationsByPkMutation,
        variables: {id}
      });
    } else {
      return of(null);
    }
  }


  clearNotifications(){
    const loginData = this.loginService.getLoginData();
    if(loginData.type === 'ADMIN'){
      return this.apollo.use('external').mutate({
        mutation: updateAdminUserNotificationsMutation,
      })
    } else if(loginData.type === 'PRACTICE'){
      return this.apollo.use('external').mutate({
        mutation: updateDentalPracticeNotificationsMutation,
      })
    } else if(loginData.type === 'PROFESSIONAL'){
      return this.apollo.use('external').mutate({
        mutation: updateDentalProfessionalNotificationsMutation,
      });
    } else if(loginData.type === 'SUPPLIER'){
      return this.apollo.use('external').mutate({
        mutation: updateDentalSupplierNotificationsMutation,
      });
    } else {
      return of(null);
    }
  }



}
